import { t } from "@lingui/macro";
import { Box, Typography } from "@mui/material";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../hooks";
import StyledButton from "./StyledButton";
import StyledPaper from "./StyledPaper";
import StyledRadio from "./StyledRadio";
import { i18n } from "@lingui/core";
import api from "../api";
import supportedLocales, { dynamicActivate } from "../utils/locales";
import userSlice from "../store/userSlice";
import dayjs from "dayjs";
require('dayjs/locale/de')
require('dayjs/locale/nl')
require('dayjs/locale/fr')
require('dayjs/locale/uk')

const MenuSidebar: React.FC = () => {
    const dispatch = useAppDispatch()

    const user = useAppSelector(state => state.user);
    const [currentLocale, setCurrentLocale] = useState<string>(user.preferedLocale || i18n.locale)

    return <Box>
        <Box display={'flex'} justifyContent={'center'}>
            <Typography>{t`Change language`}</Typography>
        </Box>
        <Box pb={'16px'} />
        {Object.entries(supportedLocales).map(([locale, label]) => <StyledPaper
            key={locale}
            sx={{ mb: '8px', padding: 0 }}
            onClick={async () => {
                await dynamicActivate(locale); //TODO: move locale management to locale service
                dispatch(userSlice.actions.setLocale(locale))
                api.changeApiLocale(locale);
                setCurrentLocale(locale);
                dayjs.locale(locale)
                user.isVerified && api.updateUserInfo({ ...user, preferedLocale: locale })
            }}
        >
            <Box display='flex' alignItems='center'>
                <StyledRadio checked={locale === currentLocale} />
                <Typography display={'flex'} alignItems={'center'} variant='body2'>{label}</Typography>
            </Box>
        </StyledPaper>
        )}
        <Box pb={'16px'} />
        {user.isVerified && <>
            <Box display={'flex'} justifyContent={'center'}>
                <Typography>{t`Info`}</Typography>
            </Box>
            <Box>
                <StyledPaper>
                    <Typography>{t`Name`}</Typography>
                    <Typography>{user.name}</Typography>
                </StyledPaper>
                <Box pb={'16px'} />
                <StyledPaper>
                    <Typography>{t`Phone Number`}</Typography>
                    <Typography>{user.phoneNumber}</Typography>

                </StyledPaper>
                <Box pb={'16px'} />
                <StyledButton fullWidth>{t`Log out`}</StyledButton>
            </Box>
        </>}
    </Box>
}

export default MenuSidebar